export default from './ForgotPassword';



// WEBPACK FOOTER //
// ./src/components/ForgotPassword/index.js